/**
 * 共通レシピ一覧表示用 レシピ・タグ定義
 */
export class CommonRecipeTag {
  id: number;   // タグID
  name: string; // タグ名

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}
/**
 * 共通レシピ一覧表示用 レシピ・食材定義
 */
export class CommonRecipeFoodId {
  id: number;   // 食材ID
  icon: string | null; // 画像URL

  constructor(id: number, icon: string | null) {
    this.id = id;
    this.icon = icon;
  }
}
/**
 * 共通レシピ一覧表示用 レシピ定義
 */
export class CommonRecipe {
  recipeId: number;             // レシピID
  groupId: number;              // グループID
  title: string;                // レシピ名
  imageUrl: string;             // レシピ画像URL
  type: string;                 // レシピ・タイプ officail/user
  applianceCategory: string;    // 使用する機器種類名
  applianceCategoryId: number;  // 使用する機器種類ID
  productId: string;            // 使用する機器
  tags: Array<CommonRecipeTag>; // タグ
  foodIds: Array<CommonRecipeFoodId>; // 食材

  constructor() {
    this.recipeId = 0;
    this.groupId = 0;
    this.title = "";
    this.imageUrl = "";
    this.type = "";
    this.applianceCategory = "";
    this.applianceCategoryId = 0;
    this.productId = "";
    this.tags = [];
    this.foodIds = [];
  }
}
